import React from 'react'
import { Button, Label, Textarea } from 'dui'
import { Send } from 'lucide-react'

interface MessageContainerProps extends React.FormHTMLAttributes<HTMLFormElement> {
  disabled: boolean
  inputValue: string
  onInputChange: (value: string) => void
  handleKeyDown: (e: React.KeyboardEvent) => void
}

const MessageContainer: React.FC<MessageContainerProps> = ({
  disabled,
  inputValue,
  onInputChange,
  handleKeyDown,
  ...props
}) => {
  return (
    <form className="w-full flex-none border-t border-gray-100 p-4" {...props}>
      <div className="flex items-center pt-2">
        <div className="flex-1 relative h-11">
          {inputValue && (
            <Label
              htmlFor="message"
              className="absolute -top-2.5 text-xs font-medium text-[#043379] bg-white px-1 z-10"
            >
              Ваша порука
            </Label>
          )}
          <Textarea
            id="message"
            placeholder="Ваша порука"
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyDown={handleKeyDown}
            className="w-full min-h-10 resize-none rounded-full border border-[#1F519B] px-4 shadow-sm focus-visible:ring-1 focus-visible:ring-blue-500 focus-visible:border-blue-500 bg-white text-[#171717] placeholder:text-gray-500"
            style={{ height: '40px', overflow: 'hidden' }}
          />
        </div>
        <Button
          disabled={disabled}
          type="submit"
          size="sm"
          className="ml-2 bg-header-bg hover:bg-blue-700 text-white rounded-full size-10 flex items-center justify-center p-0"
        >
          <Send className="size-5" />
        </Button>
      </div>
    </form>
  )
}

export default MessageContainer
